import { IItemCache } from '../IItemCacheObserver';
import { currentItemFacet } from '../../facets/ScopeFacets';
import { getItemKey } from '../items/getItemKey';
import { getItemsScope } from './getItemsScope';

/**
 * @beta
 */
export function getCurrentItemKey(itemCache: IItemCache): string | undefined {
  const {
    itemsScopeItemKey
  } = getItemsScope(itemCache);

  const currentItem = itemCache.demandItemFacet(currentItemFacet, itemsScopeItemKey);

  return getItemKey(itemCache, {
    itemKey: currentItem && currentItem.itemKey
  });
}
